import React from 'react';

import SVG from '@/shared/components/Svg';

const CheckIconV2 = ({ ...props }) => (
  <SVG width="15" height="15" viewBox="0 0 15 15" {...props}>
    <path
      d="M6.625 10.6441C6.52 10.6441 6.40916 10.6032 6.3275 10.5274L2.8275 7.22574C2.6525 7.06241 2.64083 6.78241 2.81 6.60741C2.97916 6.43241 3.25333 6.42074 3.42833 6.58991L6.61916 9.59991L11.5658 4.65324C11.735 4.48408 12.015 4.48408 12.1842 4.65324C12.3533 4.82241 12.3533 5.10241 12.1842 5.27158L6.93416 10.5216C6.84666 10.6091 6.73583 10.6499 6.625 10.6499V10.6441Z"
      fill="white"
    />
  </SVG>
);

export default CheckIconV2;
